import { render, staticRenderFns } from "./BasicInformationSectionView.vue?vue&type=template&id=6bae6f0f&scoped=true&"
import script from "./BasicInformationSectionView.vue?vue&type=script&lang=js&"
export * from "./BasicInformationSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae6f0f",
  null
  
)

export default component.exports